export default __webpack_public_path__ + "static/media/22-EXT-(2-1).a46c2710.jpg";